'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _store = require('./store');

exports.default = _store.getUserId;


//////////////////
// WEBPACK FOOTER
// ./node_modules/meteor-apollo-accounts/client/userId.js
// module id = 709
// module chunks = 21